
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1377_1518)"}},[_c('path',{attrs:{"d":"M30 0H0v20h30V0z","fill":"#D7141A"}}),_c('path',{attrs:{"d":"M30 0H0v10h30V0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15 10L0 0v20l15-10z","fill":"#11457E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1377_1518"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v20H0z"}})])])])
          )
        }
      }
    